import { render, staticRenderFns } from "./rollLegend.vue?vue&type=template&id=1200d535&"
import script from "./rollLegend.vue?vue&type=script&lang=js&"
export * from "./rollLegend.vue?vue&type=script&lang=js&"
import style0 from "./rollLegend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports